import type { PayAccountBalance } from '../../../models/sale'
import { peekPostPaymentRedirectUrl } from '../../../util/post-payment-redirect'

/**
 * Returns true when payment UI should behave as ABP flow.
 *
 * We intentionally combine both signals:
 * - redirect URL intent (set synchronously from entry URL), and
 * - ABP transaction readiness (set asynchronously after customer lookup).
 */
export const isAbpPaymentUiFlowActive = (
  payAccountBalance?: Pick<PayAccountBalance, 'abpTransactionId'> | null
): boolean => {
  return Boolean(
    peekPostPaymentRedirectUrl() || payAccountBalance?.abpTransactionId
  )
}
